import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { saveAs as importedSaveAs } from "file-saver";

import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';
import { VisitaCertificacionService } from '../services/visita-certificacion.service';


import { ReporteFacturacion } from '../Models/ReporteFacturacion';
import { VisitaCertificacion } from '../Models/visita-certificacion';

@Component({
  selector: 'app-reporte-facturacion',
  templateUrl: './reporte-facturacion.component.html',
  styleUrls: ['./reporte-facturacion.component.css']
})
export class ReporteFacturacionComponent implements OnInit {

  public reporteFacturacion: ReporteFacturacion = new ReporteFacturacion();
  public reporteFacturaciones: ReporteFacturacion[];

  public VisitaCertificacion: VisitaCertificacion = new VisitaCertificacion();
  public VisitaCertificaciones: VisitaCertificacion[];

  public path: any;

  constructor(private globalServices: GlobalsService, private ReporteViajeService: ReporteViajeService, 
    private utilesService:UtilesService , private generadorTemplate: GeneradorTemplateService,
    private visitaCertificacionService:VisitaCertificacionService,
    private domSanitizer: DomSanitizer) { }

  ngOnInit() {
  }

/**
 * Carga la firma de la certificacion
 * @param idVisita 
 */
  CargarVisitaCertiificacion(idVisita: string) {
    try {

      this.visitaCertificacionService.ObtenerVisitaCertificacion_idvisita(this.globalServices.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.VisitaCertificaciones = data;

          // if (this.VisitaCertificaciones.length==0){
          //   this.VisitaCertificaciones=[];
          //   this.VisitaCertificacion=new VisitaCertificacion();
          //   this.VisitaCertificacion.firma="";
          // }

          this.VisitaCertificacion = this.VisitaCertificaciones[0];
          this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.VisitaCertificacion.firma);
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarVisitaCertiificacion error: " + error);
    }
  }


  CargarReporteFacturacion() {
    try {

      this.VisitaCertificaciones=[];
      this.VisitaCertificacion=new VisitaCertificacion();
      this.path="";

      var numeroFactura = this.reporteFacturacion.numeroDocumento;
      this.ReporteViajeService.ObtenerReporteFacturacion(this.globalServices.ObtenerCompania(), numeroFactura).subscribe(
        data => {
          this.reporteFacturaciones = data;

          if (this.reporteFacturaciones.length == 0) {
            swal("Numero de factura no existe", "", "error");
            this.reporteFacturaciones = [];
            this.reporteFacturacion = new ReporteFacturacion();

            this.reporteFacturacion.numeroDocumento = numeroFactura;
            return;
          }

          this.reporteFacturacion = this.reporteFacturaciones[0];

          this.CargarVisitaCertiificacion(this.reporteFacturacion.idVisita);

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarReporteFacturacion error: " + error);
    }
  }




/**
 * Metodo que descarga el reporte
 */
DescargarReporte() {

if(this.reporteFacturaciones===undefined){
  swal("Numero de factura no existe", "", "error");
    this.reporteFacturaciones = [];
    this.reporteFacturacion = new ReporteFacturacion();

    
    return;
}


  if (this.reporteFacturaciones.length == 0 ) {
    swal("Numero de factura no existe", "", "error");
    this.reporteFacturaciones = [];
    this.reporteFacturacion = new ReporteFacturacion();

    
    return;
  }

  //nombre que va a tener el archivo
  var nombre =  "Reporte Facturacion " + this.reporteFacturacion.numeroDocumento;
  var archivo = this.utilesService.getURLReportes() + nombre + ".pdf" ;

  //Genera el arciho PDF en la api
  this.generadorTemplate.ReporteFacturacion(this.globalServices.ObtenerCompania(), this.reporteFacturacion.numeroDocumento, nombre ).subscribe(
    (res) => {
     
      if(res.tipoResultado==="ERROR"){
        swal("Error, "+ res.mensaje, "", "error");
          return
      }
  
      var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
      var fileName = "Reporte Facturación.pdf";

      importedSaveAs(resultado, fileName);

    }
  )
}

}
